const ConvertButton = ({ disabled, onConvert, label = 'Convert' }) => {
  return (
    <button
      type="button"
      onClick={onConvert}
      disabled={disabled}
      className="btn btn-outline-custom btn-outline-accent"
    >
      {label}
    </button>
  );
};

export default ConvertButton;
